
// Web Push notification constants
export const PUSH_CONFIG = {
  vapidPublicKey: 'BInav8E-hYoLNFPgOfluToiS1ah5FWb4_qztKv9cIh6sQ_zO_ueJSn8eFarJq8pJmaZGaCPKta7IvcW3aW_wofo',
  applicationServerKey: null as Uint8Array | null
};

// Convert VAPID key to Uint8Array for pushManager.subscribe
export function getApplicationServerKey(): BufferSource {
  if (!PUSH_CONFIG.applicationServerKey) {
    PUSH_CONFIG.applicationServerKey = urlBase64ToUint8Array(PUSH_CONFIG.vapidPublicKey);
  }
  return PUSH_CONFIG.applicationServerKey as BufferSource;
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return new Uint8Array(outputArray.buffer);
}
